<template>
  <v-container fill-height>
    <v-layout
      justify-center
      align-center
    >
      <v-flex
        sx12
        sm6
        md4
        lg3
        xl3
      >
        <v-card elevation="10">
          <v-toolbar
            color="primary"
            dark
          >
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="user.email"
                prepend-icon="mdi-email"
                name="email"
                label="E-mail"
                type="email"
                dense
              >
              </v-text-field>
              <v-text-field
                v-model="user.password"
                prepend-icon="mdi-lock"
                name="password"
                label="Senha"
                type="password"
                dense
              >
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              large
              @click.prevent="signin()"
            >
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { baseApiUrl, showError, userKey } from '@/global'
import axios from 'axios'
export default {
  name: 'Login',
  data: () => ({
    user: {}
  }),
  methods: {
    signin () {
      axios.post(`${baseApiUrl}/got/signin`, this.user)
        .then(res => {
          this.$store.commit('setUser', res.data)
          localStorage.setItem(userKey, JSON.stringify(res.data))
          this.$router.push({ path: '/' })
        })
        .catch(showError)
    }

  }
}
</script>
